#import "../fragments/sms-drip-sequence-fragment.graphql"

query GetSmsDripSequences($archived: Boolean!) {
    smsDripSequences(archived: $archived) {
        edges {
            node {
                ...SmsDripSequenceFragment
            }
        }
    }
}
